import FlowchartList from '../components/Flowchart/FlowchartList';

export default function FlowchartsPage() {
  return <FlowchartList />;
}
